import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';

import {AccountService} from '../core/ecv-http-services/services/account.service';
import {AuthService} from '../core/auth.service';
import {ValidatorService} from '../core/validator/validator.service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  public loginForm: FormGroup;

  constructor(private authService: AuthService,
              private accountService: AccountService,
              private validatorService: ValidatorService,
              private router: Router) {
  }

  ngOnInit() {
    this.createForm();
  }

  onLogIn() {
    this.validatorService.validate(this.loginForm);
    if (this.validatorService.isValid(this.loginForm)) {
      const email = this.loginForm.controls['email'].value;
      const password = this.loginForm.controls['password'].value;
      this.authService.logIn(email, password).subscribe(
        JWT => {
          this.authService.sessionService.setJWT(JWT);
          const redirectUrl = localStorage.getItem('redirect_url');
          if (redirectUrl) {
            localStorage.removeItem('redirect_url');
            this.router.navigate([redirectUrl]);
          }else {
            this.router.navigate(['/']);
          }
          this.accountService.getPersonalDetails().subscribe(response => {
            localStorage.setItem('userFirstName', response.firstName);
            localStorage.setItem('userLastName', response.lastName);
          });
        });
    }
  }

  private createForm() {
    this.loginForm = new FormGroup({
      'email': new FormControl('', [Validators.required]),
      'password': new FormControl('', [Validators.required])
    });
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/login/login.component.ts